import React, { useEffect, useState } from 'react';

import getProximityDealerItems from '../repositories/getProximityDealerItems';

import { TCarouselListingItem } from 'types/TCarousels';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

type ProximityDealersListProps = {
  favoriteAdItems: TCarouselListingItem[];
  onFavClickHandler: (item: TCarouselListingItem, isFavorite: boolean) => Promise<void>;
};

const ITEM_TYPE_PROXIMITY_DEALERS = 'proximity_dealers';
let ListingItemCarousel;

const ProximityDealersList = ({ favoriteAdItems, onFavClickHandler }: ProximityDealersListProps) => {
  const { t } = useI18nContext();
  const [proximityDealerItems, setProximityDealerItems] = useState<TCarouselListingItem[]>([]);
  const [listingItemCarouselLoaded, setListingItemCarouselLoaded] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const list = await getProximityDealerItems();
      if (!list.items.length) {
        return;
      }
      setProximityDealerItems(list.items);

      ListingItemCarousel = (
        await import(/* webpackChunkName: "ListingItemCarousel" */ '../../Carousels/components/ListingItemCarousel')
      ).default;
      setListingItemCarouselLoaded(true);
    })();
  }, []);

  if (!proximityDealerItems.length || !listingItemCarouselLoaded) {
    return null;
  }

  return (
    <ListingItemCarousel
      type={ITEM_TYPE_PROXIMITY_DEALERS}
      title={t(`cars.carousel.title.${ITEM_TYPE_PROXIMITY_DEALERS}`)}
      items={proximityDealerItems}
      favoriteAdIdList={favoriteAdItems.map(({ itemId }) => itemId)}
      onFavClickHandler={onFavClickHandler}
    />
  );
};

export default ProximityDealersList;
